export function isValidSignUpUrl(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;
  try {
    const normalized = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    const url = new URL(normalized);
    const host = url.hostname;
    return host.length > 0 && (host === "localhost" || host.includes("."));
  } catch {
    return false;
  }
}

export function isValidFoundingYear(value: string, maxYear = new Date().getFullYear()): boolean {
  const trimmed = value.trim();
  if (!/^\d{4}$/.test(trimmed)) return false;
  const year = Number(trimmed);
  return year >= 1800 && year <= maxYear;
}
